import AutoAbstractField from "./AutoAbstractField.mjs";
import {Button, ButtonGroup, Input, InputGroup, InputGroupText} from "reactstrap";

const AutoUnitValueField = class extends AutoAbstractField {
	constructor(props) {
		super(props);
		this.state.units = (props.def.units || []);
		if (!Array.isArray(this.state.units)) this.state.units = [this.state.units];
		this.state.units = this.state.units
			.map(u => {
				if (typeof u === 'number') u = String(u);
				if (typeof u === 'string') u = {label: u, value: u};
				if (!u.label) u.label = String(u.value ?? '');
				if (!u.value) u.value = String(u.label ?? '');
				if (!u.multi) {
					u.multi = 1;
				} else if (typeof u.multi === "string") {
					u.multi = parseFloat(u.multi);
					if ( isNaN(u.multi)) u.multi = parseFloat(u.multi.replace(/[^0-9,.]/g, "").replace(/,/,'.'));
					if ( isNaN(u.multi) ) u.multi = 1;
				}
				return u;
			})
			.filter(u => u?.label);
		let min = props.def.min;
		if (typeof min !== 'undefined') {
			if (typeof min === 'string') min = parseFloat(min);
			if (! isNaN(min)) this.state.min = min;
		}
		let max = props.def.max;
		if (typeof max !== 'undefined') {
			if (typeof max === 'string') max = parseFloat(max);
			if ( ! isNaN(max)) this.state.max = max;
		}
		this.state.unitIndex = this.state.units
			.map((u, i) => ({index: i, multi: u.multi}))
			.sort((a, b) => b.multi - a.multi)
			.find(u => (this.state.value > u.multi))?.index ?? 0;
		this.state.multi = this.state.units[this.state.unitIndex]?.multi || 1;
		if (typeof this.state.min === 'number' && typeof this.state.max === 'number' && props.def.slider) {
			this.state.slider = true;
		}
	}

	renderField() {
		const mw = this.state.slider ? String(parseInt(this.state.max - this.state.min) * 10).length * 24 : 160;
		return (
			<InputGroup>
				{this.state.slider && (
					<InputGroupText
						style={{width: `min(${mw * 4}px, 60vw)`}}
					>
						<Input
							type="range"
							min={this.state.min}
							max={this.state.max}
							value={(this.state.value ?? this.state.min ?? 0) / this.state.multi}
							onChange={e => {
								this.setValue(parseFloat(e.target.value || '0') * this.state.multi);
							}}
						/>
					</InputGroupText>
				)}
				<Input
					type="number"
					style={{maxWidth: `${mw}px`, textAlign: "right"}}
					value={ Math.round(10000 * (this.state.value ?? this.state.min ?? 0) / this.state.multi) / 10000 }
					min={this.state.min}
					max={this.state.max}
					onChange={e => {
						this.setValue(Math.round(10000 * parseFloat(e.target.value || '0') * this.state.multi ) / 10000);
					}}
				/>
				{this.state.units && (
					this.state.units.length === 1 ? (
						<InputGroupText>{this.state.units[0].label}</InputGroupText>
					) : (
						<InputGroupText>
							<ButtonGroup className={"btn-icon AutoButtons"}>
								{this.state.units.map((u, i) => (
									<Button
										key={i}
										active={this.state.unitIndex === i}
										onClick={() => {
											this.setState({
												unitIndex: i,
												multi: this.state.units[i].multi
											})
										}}
									>
										<b>{u.label}</b>
									</Button>
								))}
							</ButtonGroup>
						</InputGroupText>
					)
				)}
			</InputGroup>
		)
	}
}

export default AutoUnitValueField;